// -- todo - base service class
import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";
import { AuthService } from "./authService";

export class UserService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
		this._authService = new AuthService();
	}

	createUser(user, callback) {
		const url = "/ecosystem/api/users";
		const body = JSON.stringify({
			user
		});
		this._restClient.exec_post(url, body, callback);
	}

	checkUserExists(username, callback) {
		const url = `/ecosystem/api/users/exists/${username}`;
		this._restClient.exec_get(url, callback);
	}

	updateUser(userId, user, callback) {
		const url = `/ecosystem/api/users/${userId}`;
		const body = JSON.stringify({
			user
		});
		this._restClient.exec_put(url, body, callback);
	}

	setPassword(userId, currentPassword, newPassword, callback) {
		const url = `/ecosystem/api/users/${userId}/set-password`;
		const body = JSON.stringify({
			currentPassword,
			newPassword
		});
		this._restClient.exec_put(url, body, callback);
	}

	changePassword(userId, currentPassword, newPassword, adminChange, callback) {
		const url = `/ecosystem/api/users/${userId}/${adminChange ? "admin-change-password" : "change-password"}`;
		const body = JSON.stringify({
			currentPassword,
			newPassword
		});
		this._restClient.exec_put(url, body, callback);
	}

	deleteUser(userId, callback) {
		const url = `/ecosystem/api/users/${userId}`;
		this._restClient.exec_delete(url, callback);
	}

	//"config": {
	//    "role":  "Viewer" || "Collaborator"
	//}
	addApplication(userId, appId, config, callback) {
		const url = `/ecosystem/api/users/${userId}/applications/${appId}`;
		const body = JSON.stringify({
			config: config
		});
		this._restClient.exec_post(url, body, callback);
	}

	updateApplication(userId, appId, config, callback) {
		const url = `/ecosystem/api/users/${userId}/applications/${appId}`;
		const body = JSON.stringify({
			config: config
		});
		this._restClient.exec_put(url, body, callback);
	}

	removeApplication(userId, appId, callback) {
		const url = `/ecosystem/api/users/${userId}/applications/${appId}`;
		this._restClient.exec_delete(url, callback);
	}

	addIntegration(userId, intId, config, callback) {
		const url = `/ecosystem/api/users/${userId}/integrations/${intId}`;
		const body = JSON.stringify({
			config: config
		});
		this._restClient.exec_post(url, body, callback);
	}

	updateIntegration(userId, intId, config, orgIntId, callback) {
		const url = `/ecosystem/api/users/${userId}/integrations/${intId}`;
		const body = JSON.stringify({
			config: config,
			orgIntId: orgIntId
		});
		this._restClient.exec_put(url, body, callback);
	}

	removeIntegration(userId, intId, callback) {
		const url = `/ecosystem/api/users/${userId}/integrations/${intId}`;
		this._restClient.exec_delete(url, callback);
	}

	getProfile(userId, callback) {
		const url = `/ecosystem/api/users/${userId}/profile`;
		this._restClient.exec_get(url, callback);
	}

	getLightProfile(userId, callback) {
		const url = `/ecosystem/api/users/${userId}/profile_light`;
		this._restClient.exec_get(url, callback);
	}

	getMyProfile(callback) {
		const url = "/ecosystem/api/users/myProfile";
		this._restClient.exec_get(url, callback);
	}

	getAllOrgUsers(callback) {
		const url = "/ecosystem/api/users?fromOrg=true";
		this._restClient.exec_get(url, callback);
	}

	getAll(callback, ignoreInactiveUsers = true) {
		// If gets passed a callback, executes normally. Otherwise returns promise for use with async/await, etc.
		const url = "/ecosystem/api/users?ignoreInactiveUsers=" + ignoreInactiveUsers;
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	getActiveUsers(callback) {
		const url = "/ecosystem/api/users/activeUsers";
		this._restClient.exec_get(url, callback);
	}

	getAppState(app, callback) {
		const url = `/ecosystem/api/users/me/applications/${app}/state`;
		this._restClient.exec_get(url, callback);
	}

	setAppState(app, keyVal, callback) {
		const url = `/ecosystem/api/users/me/applications/${app}/state`;
		const body = JSON.stringify(keyVal);
		this._restClient.exec_put(url, body, callback);
	}

	setProfileImage(userId, fileHandle, callback) {
		const url = `/ecosystem/api/users/${userId}/image`;
		const body = JSON.stringify({
			fileHandle
		});

		if (callback) {
			this._restClient.exec_post(url, body, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_post(url, body, (err, result) => {
					if (err) {
						reject(err);
						return;
					} else {
						resolve(result);
					}
				});
			});
		}
	}

	getAppSettings(callback) {
		const url = `/ecosystem/api/users/me/appSettings`;
		this._restClient.exec_get(url, callback);
	}

	updateAppSettings(update, callback) {
		const url = `/ecosystem/api/users/me/appSettings`;
		const body = JSON.stringify({
			update: update
		});
		this._restClient.exec_put(url, body, callback);
	}

	updateRole(userId, role, callback) {
		const url = `/ecosystem/api/users/${userId}/role`;
		const body = JSON.stringify({
			role
		});
		this._restClient.exec_put(url, body, callback);
	}

	getCanAccessApp(appId, callback) {
		const url = `/ecosystem/api/users/${appId}/access`;
		this._restClient.exec_get(url, callback);
	}

	endSession(userId, callback) {
		const url = `/ecosystem/api/users/${userId}/sessions`;
		this._restClient.exec_delete(url, callback);
	}

	unlockUser(userId, callback) {
		const url = `/ecosystem/api/users/${userId}/unlock`;
		this._restClient.exec_put(url, null, callback);
	}

	bulkSaveUsers(data, callback) {
		const url = `/ecosystem/api/users/bulkSave`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	bulkSaveAccountSettings(data, callback) {
		const url = `/ecosystem/api/users/bulkSave/accountSettings`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	validatePassword(userId, currentPassword, newPassword, callback) {
		const url = `/ecosystem/api/users/${userId}/validatePassword`;
		const body = JSON.stringify({
			currentPassword,
			newPassword
		});
		this._restClient.exec_put(url, body, callback);
	}
	/**
	 * streamOnlineUsers
	 * Realtime stream of online users for the current org.
	 * Consumes ecosystem realtime pubsub: /onlineUsers
	 *
	 * @param {function} callback (err, payload) => void
	 * @returns {Promise<any>} subscription handle (for unsubscribe)
	 */
	streamOnlineUsers(callback) {
		const args = {};

		// Returns a promise that resolves to a channel you can use to unsubscribe
		return this._rc.subscribe("ecosystem", "/onlineUsers", args, msg => {
			const response = typeof msg === "string" ? JSON.parse(msg) : msg;
			if (response && callback) {
				callback(null, response);
			}
		});
	}
}
